import Lottie from "lottie-react"
import AnimationFailure from '@/icons/animations/Failure.json'
import AnimationLock from '@/icons/animations/Lock.json'
import { useHapticFeedback, useWebApp } from "@vkruglikov/react-telegram-web-app";
import { useState, useEffect } from "react";
import { animationSizes } from '@/constants'
import { useTranslation } from 'react-i18next';
import Countdown from 'react-countdown';

export default function ErrorComponent(props) {
	const [impactOccurred, notificationOccurred] = useHapticFeedback();
	const { t } = useTranslation()
	const errorsTexts = [405, 410, 423, 424, 426, 429, 990]
	const [status, setStatus] = useState('default')
	const WebApp = useWebApp();
	const [reloadLocked, setReloadLocked] = useState(true)

	const buttons = {
		426: () => WebApp.openTelegramLink(process.env.REACT_APP_LINK_TO_BOT + '?start=subscription')
	}

	useEffect(() => {
		notificationOccurred('error')

		if (typeof props.error === 'number' && errorsTexts.includes(props.error)) {
			setStatus(props.error)
			return
		}

		if (
			props.error?.response?.status &&
			errorsTexts.includes(props.error.response.status)
		) {
			setStatus(props.error.response.status)
		}
	}, [])

	return (
		<main>
			<div className='boxIntro'>
				<div className='boxIntro_sticker'>
					<Lottie animationData={status === 429 ? AnimationLock : AnimationFailure} loop={false} style={animationSizes['AnimationLock']} />
				</div>
				<div className='boxIntro_title'>{ t('errors.' + status + '.title') }</div>
				<div className='boxIntro_text'>{ t('errors.' + status + '.text') }</div>
				<div className='boxIntro_text'>{ t('errors.' + status + '.text2') }</div>
				{buttons[status] ?
					<button className='btn btn--tt-none btn-block' onClick={buttons[status]}>{ t('errors.' + status + '.btn') }</button>
				: null}
				{status === 'default' ?
					<>
						{reloadLocked && (
							<div className='boxIntro_countdown'>
								<Countdown
									date={Date.now() + 5000}
									renderer={({ completed, formatted }) => {
										if (completed) {
											if (reloadLocked) {
												setReloadLocked(false)
											}
											return null
										}

										return (
											<span className='boxIntro_countdown-timer'>
												00:{formatted.seconds}
											</span>
										)
									}}
								/>
							</div>
						)}
						<button
							className='btn btn--tt-none btn-block'
							disabled={reloadLocked}
							onClick={() => {
								if (!reloadLocked) {
									window.location.reload()
								}
							}}
						>
							{ t('errors.default.btn') }
						</button>
					</>
				: null}
			</div>
		</main>
    );
};
